import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetMyGameplayResults } from "../../api-clients/tournamentsClient";

interface UseGameplayResultsQueryParams {
  limit?: number;
  enabled?: boolean;
}

function useGameplayResultsQuery(params?: UseGameplayResultsQueryParams) {
  const { limit = 5, enabled = true } = params ?? {};

  return useQuery({
    queryKey: [QUERY_KEYS.TOURNAMENT.GAMEPLAY_RESULTS, limit],
    queryFn: () => handleGetMyGameplayResults(limit),
    enabled: enabled,
  });
}

export default useGameplayResultsQuery;
